var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRoomSceneryDoor({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 92,
    height: 186,
    viewBox: "0 0 92 186",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#D7D7D7",
    stroke: "#F4F4F4",
    d: "M.5.5h91v185H.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D7D7D7",
    stroke: "#F4F4F4",
    d: "M10.5 10.5h72v175h-72z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D7D7D7",
    d: "M21 106h51v64H21z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D7D7D7",
    stroke: "#F4F4F4",
    d: "M21.5 106.5h50v63h-50zM71.5 90.5v-47c0-13.807-11.193-25-25-25s-25 11.193-25 25v47h50z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#D7D7D7",
    cx: 18.5,
    cy: 98.5,
    r: 4,
    stroke: "#F4F4F4"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoomSceneryDoor);
export default __webpack_public_path__ + "static/media/RoomSceneryDoor.ff651a0ae7c96ebb0dd327ad9ae5d974.svg";
export { ForwardRef as ReactComponent };